import React, { useState } from 'react';
import useTrans from '@/hooks/useTrans';
import styles from './ab.module.css';

const AboutHNG = () => {
    const trans = useTrans();
    return (
        <div className={styles.aff_about}>
            <div className={styles.aff_about_content}>
                <div className={styles.aff_about_container}>
                    <div className={styles.aff_about_t} data-aos='fade-right'>
                    <h2>{trans?.mobile_app?.about}</h2>
                    <p
                        dangerouslySetInnerHTML={{
                        __html: trans?.mobile_app?.about_text,
                        }}
                    ></p>
                    </div>
                    <div className={styles.aff_img_ab} data-aos='fade-left'>
                    <img src='/assets/img/aff/ab.png' alt='' className='lazyload' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutHNG;